import styled from 'styled-components';
import { Table } from 'src/ui/common/molecules/table';
import { FlexBox } from 'src/ui/common/atoms/flex-box';

export const StyledRow = styled(Table.Row)`
  white-space: nowrap;
  height: 45px;
  
  &:hover {
    background: #292929;
  }
`;

export const StyledWalletWrapper = styled.div`
  display: inline-block;
`;

export const StyledWallet = styled(FlexBox)`
  display: inline-flex !important;
  cursor: pointer;
  
  & > div {
    max-width: 150px;
  }
  
  & svg {
    opacity: 0;
    visibility: hidden;
    margin-left: 6px;
    width: 18px;
    color: ${({ theme }) => theme.colors.gs200};
  }
  
  &:hover svg {
    opacity: 1;
    visibility: visible;
  }
`;
